var _defs, _path, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeSunsetPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CHOIX_02",
    "data-name": "CHOIX 02",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 172.989,
    height: 208.458,
    viewBox: "0 0 172.989 208.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13177",
    "data-name": "Path 13177",
    d: "M11.736,0H161.253a11.736,11.736,0,0,1,11.736,11.736V196.722a11.736,11.736,0,0,1-11.736,11.736H11.736A11.736,11.736,0,0,1,0,196.722V11.736A11.736,11.736,0,0,1,11.736,0Z",
    fill: "#ee987c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 0.5,
    x2: 0.619,
    y2: 0.722,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fad78a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07c6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#272b5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07c6d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13176",
    "data-name": "Path 13176",
    d: "M11.736,0H161.253a11.736,11.736,0,0,1,11.736,11.736V196.722a11.736,11.736,0,0,1-11.736,11.736H11.736A11.736,11.736,0,0,1,0,196.722V11.736A11.736,11.736,0,0,1,11.736,0Z",
    transform: "translate(0 0)",
    fill: "#ee987c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_66",
    "data-name": "Mask Group 66",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6347",
    "data-name": "Group 6347",
    transform: "translate(-70.04 100.171)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "SUN",
    cx: 28.461,
    cy: 28.461,
    rx: 28.461,
    ry: 28.461,
    transform: "translate(83.788 21.053)",
    fill: "url(#linear-gradient1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-11",
    d: "M505.8,52.19H461.24L0,86.72q1.92-7.573,6.558-10.06c4.01-2.15,7.522-4.94,16.748-4.94,17.569,0,69.593-11.47,104.1-24.648,13.8-5.269,23.678-19.7,29.148-20.158,11.443-.953,16.888-7.847,26.318-8.546,11.122-.824,23.09,4.165,33.547,3.167,14.35-1.37,30.94-10.559,55.755-7.386,9.626,1.231,29.695-6.833,51.578-6.959,10.536-.061,34.285-5.385,47.062-5.541,6.458-.079,16.383-3.661,27.551-.012,7.36,2.405,15.61,12.607,22.523,12.507C434.417,13.95,474.692,12.8,505.8,52.19Z",
    transform: "translate(4.539 0) rotate(3)",
    fill: "url(#linear-gradient-2)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_70",
    "data-name": "Mask Group 70",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M641.467,431.234c-9.933,11.167-22.477,17.833-36.114,17.833s-26.18-6.666-36.114-17.833c-9.933,11.167-22.476,17.833-36.113,17.833s-26.181-6.666-36.114-17.833c-9.933,11.167-22.476,17.833-36.114,17.833s-26.18-6.666-36.113-17.833c-9.933,11.167-22.477,17.833-36.114,17.833s-26.18-6.666-36.114-17.833c-9.933,11.167-22.476,17.833-36.113,17.833s-26.181-6.666-36.114-17.833c-9.933,11.167-22.476,17.833-36.114,17.833s-26.18-6.666-36.113-17.833c-9.933,11.167-22.477,17.833-36.114,17.833s-26.18-6.666-36.114-17.833c-9.933,11.167-22.476,17.833-36.113,17.833S73.585,442.4,63.652,431.234C53.72,442.4,41.177,449.067,27.539,449.067c-9.961,0-19.336-3.56-27.539-9.829v31.524H655.706V443.025A57.918,57.918,0,0,1,641.467,431.234Z",
    transform: "translate(-92.301 -274.894)",
    fill: "#386c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M641.467,431.234a52.767,52.767,0,0,1-72.227,0,52.766,52.766,0,0,1-72.227,0,52.766,52.766,0,0,1-72.227,0,52.767,52.767,0,0,1-72.227,0,52.766,52.766,0,0,1-72.227,0,52.766,52.766,0,0,1-72.226,0,52.767,52.767,0,0,1-72.227,0,52.766,52.766,0,0,1-72.226,0,53.728,53.728,0,0,1-36.114,14.294A52.452,52.452,0,0,1,0,437.65v6.767A52.449,52.449,0,0,0,27.539,452.3,53.729,53.729,0,0,0,63.652,438a52.766,52.766,0,0,0,72.226,0,52.767,52.767,0,0,0,72.227,0,52.766,52.766,0,0,0,72.226,0,52.766,52.766,0,0,0,72.227,0,52.767,52.767,0,0,0,72.227,0,52.766,52.766,0,0,0,72.227,0,52.766,52.766,0,0,0,72.227,0,52.767,52.767,0,0,0,72.227,0,57.073,57.073,0,0,0,14.239,9.451v-6.768A57.06,57.06,0,0,1,641.467,431.234Z",
    transform: "translate(-92.301 -274.894)",
    fill: "#386c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_01",
    "data-name": "CLOUD 01",
    d: "M320.061,79.277a2.425,2.425,0,0,0,2.317-3.561,12.019,12.019,0,0,0-10.335-5.593,12.5,12.5,0,0,0-6.548,1.823,24,24,0,0,0-20.73-11.314,25.277,25.277,0,0,0-9.388,1.79c-5.215-8.549-15.144-14.328-26.544-14.328-13.8,0-25.446,8.464-29.179,20.063a21.448,21.448,0,0,0-3.72-.327,20.313,20.313,0,0,0-15.647,7.112,9.757,9.757,0,0,0-7.417-.318,2.4,2.4,0,0,0,1.014,4.654Z",
    transform: "translate(-183.476 -7.924)",
    fill: "#f7a78e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294-2",
    "data-name": "Path 2294",
    d: "M594.9,431.234c-9.211,11.167-20.845,17.833-33.492,17.833s-24.28-6.666-33.492-17.833c-9.212,11.167-20.844,17.833-33.491,17.833s-24.28-6.666-33.492-17.833c-9.212,11.167-20.844,17.833-33.492,17.833s-24.279-6.666-33.491-17.833c-9.211,11.167-20.845,17.833-33.492,17.833s-24.28-6.666-33.492-17.833c-9.212,11.167-20.844,17.833-33.491,17.833s-24.28-6.666-33.492-17.833c-9.212,11.167-20.844,17.833-33.492,17.833S202.21,442.4,193,431.234c-9.212,11.167-20.845,17.833-33.492,17.833s-24.279-6.666-33.492-17.833C116.8,442.4,105.17,449.067,92.523,449.067s-24.28-6.666-33.492-17.833C49.82,442.4,38.187,449.067,25.54,449.067c-9.237,0-17.933-3.56-25.54-9.829v31.524H608.1V443.025A54.835,54.835,0,0,1,594.9,431.234Z",
    transform: "translate(-303.128 -261.573)",
    fill: "#4282a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295-2",
    "data-name": "Path 2295",
    d: "M594.9,431.234c-9.211,8.951-20.845,14.294-33.492,14.294s-24.28-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.491,14.294s-24.28-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.492,14.294s-24.279-5.343-33.491-14.294c-9.211,8.951-20.845,14.294-33.492,14.294s-24.28-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.491,14.294s-24.28-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.492,14.294S202.21,440.185,193,431.234c-9.212,8.951-20.845,14.294-33.492,14.294s-24.279-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.491,14.294s-24.28-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.492,14.294A46.068,46.068,0,0,1,0,437.65v6.767A46.065,46.065,0,0,0,25.54,452.3c12.648,0,24.28-5.343,33.492-14.294,9.212,8.951,20.844,14.294,33.492,14.294S116.8,446.953,126.014,438c9.212,8.951,20.845,14.294,33.492,14.294S183.786,446.953,193,438c9.212,8.951,20.844,14.294,33.491,14.294s24.28-5.343,33.492-14.294c9.212,8.951,20.844,14.294,33.492,14.294s24.28-5.343,33.491-14.294c9.212,8.951,20.845,14.294,33.492,14.294s24.28-5.343,33.492-14.294c9.212,8.951,20.844,14.294,33.491,14.294s24.28-5.343,33.492-14.294c9.211,8.951,20.844,14.294,33.492,14.294S518.7,446.953,527.913,438c9.212,8.951,20.845,14.294,33.492,14.294S585.686,446.953,594.9,438a52.811,52.811,0,0,0,13.206,9.451v-6.768A52.8,52.8,0,0,1,594.9,431.234Z",
    transform: "translate(-303.128 -261.573)",
    fill: "#79b0d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "BOAT_16",
    "data-name": "BOAT 16",
    transform: "translate(-47.407 122.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7525",
    "data-name": "Path 7525",
    d: "M310.025,301.331c1.982-.125,4.484-.279,7.389-.463,0,0,30.664-7.191,47.775-17.769-1.292-.773-2.057-1.159-2.057-1.159C344.308,293.609,310.025,301.331,310.025,301.331Z",
    transform: "translate(-251.007 -266.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7526",
    "data-name": "Path 7526",
    d: "M444.9,307.456l6.86,7.886s3.383-.714,7.993-1.728V313.6l-10.764-6.149Z",
    transform: "translate(-444.9 -270.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7527",
    "data-name": "Path 7527",
    d: "M455.409,307.456l6.491,7.461c-1.251.268-1.992.425-1.992.425l-6.86-7.886Z",
    transform: "translate(-453.048 -270.265)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7528",
    "data-name": "Path 7528",
    d: "M211.644,320.245l5.928,14.565c110.833,0,156.341-6.746,157.147-6.872h.008c10.773-7.577,15.584-16.485,20.79-17.586l-147.164,7.915Z",
    transform: "translate(-208.882 -270.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7529",
    "data-name": "Path 7529",
    d: "M451.815,322.038l6.77,14.562c-.943,0-.755,0-1.708,0l-5.928-14.565Z",
    transform: "translate(-448.187 -272.502)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7530",
    "data-name": "Path 7530",
    d: "M211.644,316.572l147.165-7.915c-.345-.28-11.059-8.619-30.227-9.353h-.042C296.121,299.314,251.074,307.122,211.644,316.572Z",
    transform: "translate(-172.173 -269.014)",
    fill: "#ce6f3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7531",
    "data-name": "Path 7531",
    d: "M256.843,324.527s3.383-.715,7.993-1.728c4.268-.948,9.582-2.155,14.2-3.294a18.607,18.607,0,0,0,9.542-5.973c5.561-7.528,21.624-9.2,15.489-1.845l-.106,3.061s1.838-.115,5.037-.318c1.982-.125,4.484-.279,7.389-.463,15.726-.975,43.292-2.616,64.249-3.562,9.7-.434,17.986-.724,23.032-.724.907,0,1.805.019,2.678.057-32.419.01-77.466,7.818-116.9,17.268l-36.709,1.978Z",
    transform: "translate(-249.982 -279.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3434",
    "data-name": "Group 3434",
    transform: "translate(2.762 32.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7532",
    "data-name": "Path 7532",
    d: "M400.4,323.879c-3.5.863-14.408,2.91-19.579,4.376a13.518,13.518,0,0,0-4.963,2.648l-1.338,1.114-4.907.264,4.1-4.459s3.383-.715,7.993-1.728c4.268-.948,9.582-2.155,14.2-3.294a18.608,18.608,0,0,0,9.543-5.973C411.265,310.259,404.014,322.988,400.4,323.879Z",
    transform: "translate(-369.611 -314.953)",
    fill: "#e0e8f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7533",
    "data-name": "Path 7533",
    d: "M335.431,283.309c-17.112,10.578-47.775,17.769-47.775,17.769,15.726-.975,43.292-2.616,64.249-3.562A66.033,66.033,0,0,0,335.431,283.309Z",
    transform: "translate(-221.249 -266.56)",
    fill: "#adebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7540",
    "data-name": "Path 7540",
    d: "M212.465,322.694l-.79-1.942a.377.377,0,0,1,.28-.533l36.223-1.952L368.439,311.8h0l26.9-1.447c-5.206,1.1-10.017,10.009-20.79,17.586h-.008c-8.321,5.849-20.21,10.887-38.6,10.887H219.233a.325.325,0,0,1-.3-.216l-1.541-3.8c55.742,0,94.955-1.706,120.272-3.418a32.573,32.573,0,0,0,19.381-8.342c3.2-2.831,6.1-5.653,8.7-8.37.226-.235.063-.664-.24-.637C319.878,318.168,248.178,321,248.178,321l-35.4,1.908A.324.324,0,0,1,212.465,322.694Z",
    transform: "translate(-208.707 -270.709)",
    fill: "#e0e8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7541",
    "data-name": "Path 7541",
    d: "M320.426,319.7s-21.151,3.644-67.681,7.287c0,0,48.419-.906,66.612-3.644Z",
    transform: "translate(-164.059 -272.143)",
    fill: "#e0e8f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16083",
    "data-name": "Path 16083",
    d: "M594.9,431.234c-9.211,11.167-20.845,17.833-33.492,17.833s-24.28-6.666-33.492-17.833c-9.212,11.167-20.844,17.833-33.491,17.833s-24.28-6.666-33.492-17.833c-9.212,11.167-20.844,17.833-33.492,17.833s-24.279-6.666-33.491-17.833c-9.211,11.167-20.845,17.833-33.492,17.833s-24.28-6.666-33.492-17.833c-9.212,11.167-20.844,17.833-33.491,17.833s-24.28-6.666-33.492-17.833c-9.212,11.167-20.844,17.833-33.492,17.833S202.21,442.4,193,431.234c-9.212,11.167-20.845,17.833-33.492,17.833s-24.279-6.666-33.492-17.833C116.8,442.4,105.17,449.067,92.523,449.067s-24.28-6.666-33.492-17.833C49.82,442.4,38.187,449.067,25.54,449.067c-9.237,0-17.933-3.56-25.54-9.829v31.524H608.1V443.025A54.835,54.835,0,0,1,594.9,431.234Z",
    transform: "translate(-303.128 -261.572)",
    fill: "#4282a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16084",
    "data-name": "Path 16084",
    d: "M594.9,431.234c-9.211,8.951-20.845,14.294-33.492,14.294s-24.28-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.491,14.294s-24.28-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.492,14.294s-24.279-5.343-33.491-14.294c-9.211,8.951-20.845,14.294-33.492,14.294s-24.28-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.491,14.294s-24.28-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.492,14.294S202.21,440.185,193,431.234c-9.212,8.951-20.845,14.294-33.492,14.294s-24.279-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.491,14.294s-24.28-5.343-33.492-14.294c-9.212,8.951-20.844,14.294-33.492,14.294A46.068,46.068,0,0,1,0,437.65v6.767A46.065,46.065,0,0,0,25.54,452.3c12.648,0,24.28-5.343,33.492-14.294,9.212,8.951,20.844,14.294,33.492,14.294S116.8,446.953,126.014,438c9.212,8.951,20.845,14.294,33.492,14.294S183.786,446.953,193,438c9.212,8.951,20.844,14.294,33.491,14.294s24.28-5.343,33.492-14.294c9.212,8.951,20.844,14.294,33.492,14.294s24.28-5.343,33.491-14.294c9.212,8.951,20.845,14.294,33.492,14.294s24.28-5.343,33.492-14.294c9.212,8.951,20.844,14.294,33.491,14.294s24.28-5.343,33.492-14.294c9.211,8.951,20.844,14.294,33.492,14.294S518.7,446.953,527.913,438c9.212,8.951,20.845,14.294,33.492,14.294S585.686,446.953,594.9,438a52.811,52.811,0,0,0,13.206,9.451v-6.768A52.8,52.8,0,0,1,594.9,431.234Z",
    transform: "translate(-303.128 -261.572)",
    fill: "#79b0d1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeSunsetPreview);
export default __webpack_public_path__ + "static/media/theme-sunset-preview.f2a79b91.svg";
export { ForwardRef as ReactComponent };